import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Logo } from 'components/logo'
import { useHistory, useLocation } from 'react-router-dom'
import Button from 'components/button'
import moment from 'moment'
import './style.scss'
import ResetPasswordModal from '../employees/reset-password'
import Notification from 'antd/es/notification'
import { Employee } from '../../models'
import { Menu, Dropdown } from 'antd'
import { useEmployees } from 'context/employees'
import { useCurrentUser } from 'context/current-user'
import { useEmployeeReporting } from 'context/employee-reporting'
import startCase from 'lodash/startCase'

type Locations = 'all' | 'turku' | 'pori' | 'espoo'

const Header = () => {
  const { logOut, currentUser } = useCurrentUser()

  const history = useHistory()
  const location = useLocation()
  const [locationSelector, _setLocationSelector] = useState<Locations>((localStorage.getItem('locationSelector') as Locations) || 'all')
  const [showResetPasswordModal, setShowResetPasswordModal] = useState<Employee | undefined>()
  const [currentUserObj, setCurrentUserObj] = useState<Employee | undefined>()

  const { updatePassword } = useEmployees()

  const { setDefaultQueryParams } = useEmployeeReporting()

  const setLocationSelector = (value: 'all' | 'turku' | 'pori' | 'espoo') => {
    localStorage.setItem('locationSelector', value)
    _setLocationSelector(value)
    setDefaultQueryParams()
    window.location.reload()
  }

  const showCitySelector = () => {
    if (currentUser?.roles.includes('Admin') && locationSelector != null) {
      return true
    }
    return false
  }

  useEffect(() => {
    if (!currentUser?.roles.includes('Admin')) {
      localStorage.setItem('locationSelector', 'all')
    }
    if (currentUser) {
      setCurrentUserObj(new Employee(currentUser))
    }
  }, [])

  // @ts-ignore
  return (
    <div className="c-header">
      {/* Reset Password */}
      <ResetPasswordModal
        visible={showResetPasswordModal}
        onCancel={() => {
          setShowResetPasswordModal(undefined)
        }}
        onSave={async (value) => {
          try {
            await updatePassword(value)
            Notification.success({ message: 'Salasana muutettiin' })
            setShowResetPasswordModal(undefined)
          } catch (e) {
            console.log(e)
            Notification.error({ message: JSON.stringify(e) })
            setShowResetPasswordModal(undefined)
          }
        }}
      />
      <div className="c-header__logo">
        <Logo imageUrl={'/aputeam.png'} />
      </div>
      <div className="c-header__timestamp s-show-on-print">{moment().format('DD.MMMM YYYY HH:mm')}</div>
      <div className="c-header__menu">
        <Button.ButtonGroup style={{ flex: 2 }}>
          {currentUser?.roles.includes('Admin') && (
            <>
              <Button
                label={global.Translations.get('customers')}
                color={location.pathname.includes('/customers') ? 'red' : 'default'}
                active={location.pathname.includes('/customers')}
                hideLabelOnMobile={true}
                icon={<i className="fas fa-building"></i>}
                onClick={() => {
                  history.push('/customers')
                }}
                style={{ marginRight: '2px' }}
              />
              <Button
                color={location.pathname.includes('/employees') ? 'red' : 'default'}
                label={global.Translations.get('employees')}
                active={location.pathname.includes('/employees')}
                hideLabelOnMobile={true}
                icon={<i className="fas fa-users"></i>}
                onClick={() => {
                  history.push('/employees')
                }}
                style={{ marginRight: '2px' }}
              />
            </>
          )}
          <Button
            color={location.pathname.includes('/employee-reporting') ? 'red' : 'default'}
            label={'Tuntikirjaus'}
            icon={<i className="fas fa-user"></i>}
            hideLabelOnMobile={true}
            onClick={() => {
              if (currentUser?.roles.includes('Admin')) {
                history.push(`/employee-reporting`)
              } else {
                history.push(`/employee-reporting?employeeId=${currentUser?._id}`)
              }
            }}
            style={{ marginRight: '0.5em' }}
          />
        </Button.ButtonGroup>
        {false && !currentUser?.roles.includes('Admin') && (
          <div>
            <Button
              color="green"
              label="Palauta"
              onClick={() => {
                setShowResetPasswordModal(currentUserObj)
              }}
            />
          </div>
        )}
        {currentUser?.roles.includes('Admin')}
        {/* {showCitySelector() && (
          <Select

            defaultValue={locationSelector}
            onChange={handleChange}
            className="header-dropdown-select"
          >
            <Select.Option value={'all'}>Kaikki</Select.Option>
            <Select.Option value={'pori'}>Pori</Select.Option>
            <Select.Option value={'turku'}>Turku</Select.Option>
            <Select.Option value={'espoo'}>Espoo</Select.Option>
          </Select>
        )} */}
        <Dropdown
          overlay={
            <Menu style={{ width: '200px' }}>
              {showCitySelector() && (
                <>
                  <Menu.Item>Valitse sijainti</Menu.Item>
                  <Menu.Item>
                    <Button
                      style={{ width: '100%' }}
                      label="Kaikki"
                      onClick={() => {
                        setLocationSelector('all')
                      }}
                      color={locationSelector === 'all' ? 'green' : 'default'}
                    />{' '}
                  </Menu.Item>
                  <Menu.Item>
                    <Button
                      style={{ width: '100%' }}
                      label="Espoo"
                      onClick={() => {
                        setLocationSelector('espoo')
                      }}
                      color={locationSelector === 'espoo' ? 'green' : 'default'}
                    />{' '}
                  </Menu.Item>
                  <Menu.Item>
                    <Button
                      style={{ width: '100%' }}
                      label="Pori"
                      onClick={() => {
                        setLocationSelector('pori')
                      }}
                      color={locationSelector === 'pori' ? 'green' : 'default'}
                    />{' '}
                  </Menu.Item>
                  <Menu.Item>
                    <Button
                      style={{ width: '100%' }}
                      label="Turku"
                      onClick={() => {
                        setLocationSelector('turku')
                      }}
                      color={locationSelector === 'turku' ? 'green' : 'default'}
                    />{' '}
                  </Menu.Item>
                </>
              )}
              <Menu.Item
                style={{}}
                onClick={() => {
                  logOut()
                  history.push(`/`)
                }}
              >
                Kirjaudu Ulos
              </Menu.Item>
            </Menu>
          }
        >
          <div style={{ cursor: 'pointer', display: 'flex', marginRight: '1em', alignItems: 'center' }}>
            <div style={{ position: 'relative' }}>
              <div>
                {currentUser?.last_name} {currentUser?.first_name}
              </div>
              <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                {locationSelector !== 'all' && (
                  <div style={{ fontSize: '11px', color: 'rgba(62, 153, 24,1)', fontWeight: 400 }}>{startCase(locationSelector)}</div>
                )}
              </div>
            </div>
            {locationSelector && (
              <div style={{ marginLeft: '1em', fontSize: '1.5em' }}>
                <i className="fas fa-user"></i>
              </div>
            )}
          </div>
        </Dropdown>
      </div>
    </div>
  )
}

export default Header
